import React from 'react';

import InstagramLogo from '../../svgs/instagram-brands.svg';
import FacebookLogo from '../../svgs/facebook-f-brands.svg';
import TwitterLogo from '../../svgs/twitter-brands.svg';
import YoutubeLogo from '../../svgs/youtube.svg';

import './SocialMediaButtons.scss';

// TEALIUM
import initTealiumTracker from 'tealium-tracker';
let tealiumTrackEvent;
if (typeof window !== 'undefined') {
  const { trackEvent } = initTealiumTracker({ debugMode: true });
  tealiumTrackEvent = trackEvent;
}

const logos = {
  Instagram: <InstagramLogo className="social__logo" />,
  Facebook: <FacebookLogo className="social__logo" />,
  Twitter: <TwitterLogo className="social__logo" />,
  Youtube: <YoutubeLogo className="social__logo" />,
};

const SocialMediaButtons = ({ links, account, analytics }) => {
  return (
    <div className="social__container">
      {links.map((link) => (
        <a
          key={link.name}
          href={link.url}
          target="_blank"
          className="social__link"
          aria-label={`${account} on ${link.name}`}
          rel="noopener noreferrer"
          onClick={() => {
            // quantum tag
            analytics.track(
              'SpectrumOnDemand_selectAction_socialMediaExternal',
              { currPageElemStdName: link.name.toLowerCase() }
            );

            tealiumTrackEvent({
              linktype: 'social-footer',
              linkname: link.name.toLowerCase(),
            });
          }}
          data-linktype="social-footer"
          data-linkname={link.name.toLowerCase()}
        >
          {logos[link.name]}
        </a>
      ))}
    </div>
  );
};

export default SocialMediaButtons;
